/* LAB_2027 product template behaviour. Safe to load more than once. */
(function () {
  if (window.__lab27) return;
  window.__lab27 = true;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  // Engelsk på /en (html lang="en"), ellers norsk
  var EN = /^en/i.test(document.documentElement.lang || '');
  var T = function (en, no) { return EN ? en : no; };

  function initMain(root) {
    var main = root.querySelector('[data-l27-gmain]');
    var vid = root.querySelector('[data-l27-gvideo]');
    $$('[data-l27-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-l27-video');
        if (vid) {
          if (v) {
            if (vid.getAttribute('src') !== v) vid.src = v;
            vid.poster = b.getAttribute('data-l27-thumb');
            vid.hidden = false; if (main) main.hidden = true;
            var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
            return mark();
          }
          vid.pause(); vid.hidden = true; if (main) main.hidden = false;
        }
        if (main) main.src = b.getAttribute('data-l27-thumb');
        mark();
      });
      function mark() {
        $$('[data-l27-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      }
    });
    var vsel = root.querySelector('[data-l27-variant]');
    if (vsel) vsel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', vsel.value);
      window.location.href = url.toString();
    });
    var row = root.querySelector('[data-l27-chips]');
    if (row) {
      var more = row.querySelector('[data-l27-chipmore]');
      var chips = $$('.l27-chip:not([data-l27-chipmore])', row);
      var fit = function () {
        chips.forEach(function (c) { c.classList.remove('is-over'); });
        if (row.classList.contains('is-open')) { more.hidden = false; more.textContent = T('Show fewer', 'Vis færre'); more.setAttribute('aria-expanded', 'true'); return; }
        more.hidden = true; more.setAttribute('aria-expanded', 'false');
        if (row.scrollWidth <= row.clientWidth + 1) return;
        more.hidden = false; more.textContent = '+1';
        var n = 0;
        while (n < chips.length - 1 && row.scrollWidth > row.clientWidth + 1) {
          n++; chips[chips.length - n].classList.add('is-over'); more.textContent = '+' + n;
        }
        more.setAttribute('aria-label', T('Show ' + n + ' more ingredients', 'Vis ' + n + ' flere ingredienser'));
      };
      more.addEventListener('click', function () { row.classList.toggle('is-open'); more.removeAttribute('aria-label'); fit(); });
      var ft; window.addEventListener('resize', function () { clearTimeout(ft); ft = setTimeout(fit, 120); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      fit();
    }
    var pts = root.querySelector('[data-l27-points]');
    var pmapEl = root.querySelector('[data-l27-pmap]');
    var form = root.querySelector('[data-l27-form]');
    if (pts && form) {
      var pct = +pts.getAttribute('data-pct') || 0, pmap = {};
      try { pmap = pmapEl ? JSON.parse(pmapEl.textContent) : {}; } catch (e) { pmap = {}; }
      var calcPts = function () {
        var r = form.querySelector('input[name="selling_plan"]:checked') || form.querySelector('select[name="selling_plan"], input[name="selling_plan"]:not([type="radio"])');
        var key = r ? (r.value || '') : '';
        var price = pmap.hasOwnProperty(key) ? pmap[key] : pmap[''];
        if (typeof price !== 'number') return;
        var v = String(Math.round(price * pct / 10000));
        if (pts.textContent !== v) pts.textContent = v;
      };
      var ptT; var ptLater = function () { clearTimeout(ptT); ptT = setTimeout(calcPts, 60); };
      form.addEventListener('change', ptLater);
      form.addEventListener('click', ptLater);
      calcPts();
    }
    var mbar = root.querySelector('[data-l27-mbar]');
    var cta = root.querySelector('[data-l27-cta]');
    if (mbar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { mbar.classList.toggle('is-away', e.isIntersecting); }); }).observe(cta);
    }
  }

  function initClinical(root) {
    $$('[data-l27-tab]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-l27-tab');
        $$('[data-l27-tab]', root).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        $$('[data-l27-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-l27-panel') !== n; });
      });
    });
    $$('[data-l27-ba]', root).forEach(initBA);
  }

  function initBA(ba) {
    var slider = ba.querySelector('.l27-slider');
    var range = ba.querySelector('[data-l27-range]');
    var b0 = ba.querySelector('[data-l27-b0]'), b1 = ba.querySelector('[data-l27-b1]');
    var subj = 'a', view = 'gray';
    function setBA() {
      var s0 = ba.getAttribute('data-' + subj + '-' + view + '-0'), s1 = ba.getAttribute('data-' + subj + '-' + view + '-1');
      if (s0) b0.src = s0;
      if (s1) b1.src = s1;
    }
    if (range) range.addEventListener('input', function () { slider.style.setProperty('--x', range.value + '%'); });
    $$('[data-l27-subj]', ba).forEach(function (b) {
      b.addEventListener('click', function () {
        subj = b.getAttribute('data-l27-subj');
        $$('[data-l27-subj]', ba).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        setBA();
      });
    });
    $$('[data-l27-view]', ba).forEach(function (b) {
      b.addEventListener('click', function () {
        view = b.getAttribute('data-l27-view');
        $$('[data-l27-view]', ba).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        setBA();
      });
    });
  }

  var ICON = {
    sun: '<svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" stroke-width="1.5"/><g stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6"/></g></svg>',
    moon: '<svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true"><path d="M19.5 14.6A8 8 0 0 1 9.4 4.5a8 8 0 1 0 10.1 10.1z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    both: '<svg width="34" height="34" viewBox="0 0 24 24" aria-hidden="true"><circle cx="8" cy="8.5" r="3" fill="none" stroke="currentColor" stroke-width="1.4"/><g stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M8 2.4v1.3M8 13.3v1.3M1.9 8.5h1.3M12.8 8.5h1.3M3.7 4.2l.9.9M11.4 11.9l.9.9M3.7 12.8l.9-.9M11.4 5.1l.9-.9"/></g><path d="M22 17.6a5.6 5.6 0 0 1-7.1-7.1 5.6 5.6 0 1 0 7.1 7.1z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    check: '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" style="color:var(--l-brown)"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initCompare(root) {
    var shop, data;
    try { shop = JSON.parse(root.querySelector('[data-l27-shop]').textContent); data = JSON.parse(root.querySelector('[data-l27-data]').textContent); } catch (e) { return; }
    var lines = data.lines, info = data.products;
    var list = shop.filter(function (p) { return info[p.handle]; });
    if (list.length < 2) return;
    var by = {}; list.forEach(function (p) { by[p.handle] = p; });
    var cur = root.getAttribute('data-current');
    var sel = [by[cur] ? cur : list[0].handle, root.getAttribute('data-def2'), root.getAttribute('data-def3')].map(function (h, i) {
      return by[h] ? h : list[Math.min(i, list.length - 1)].handle;
    });
    var hidden = {}, diffOnly = false;
    var out = root.querySelector('[data-l27-cmp]');
    var dash = '<span class="l27-dash" aria-label="' + T('Not available', 'Ikke tilgjengelig') + '">—</span>';
    function d(p) { return info[p.handle]; }
    var ROWS = [
      ['sum', T('Summary', 'Oppsummering'), [
        [T('Range', 'Serie'), function (p) { var l = lines[d(p).line]; return '<span class="l27-dot" style="background:' + l.c + ';margin-bottom:4px"></span><span>' + esc(l.label) + '</span>'; }],
        [T('Use', 'Bruk'), function (p) { var m = { day: ['sun', T('Morning', 'Morgen')], night: ['moon', T('Evening', 'Kveld')], both: ['both', T('Morning and evening', 'Morgen og kveld')] }[d(p).time]; return '<span style="color:var(--l-brown)">' + ICON[m[0]] + '</span><span>' + m[1] + '</span>'; }],
        [T('Key ingredient', 'Nøkkelingrediens'), function (p) { var a = d(p).actives[0]; return '<span class="l27-bigv" style="color:var(--l-brown)">' + esc(a[1] || '—') + '</span><small>' + esc(a[0]) + '</small>'; }],
        [T('Skin concern', 'Hudbehov'), function (p) { return esc(d(p).concern); }]
      ]],
      ['act', T('Key ingredients', 'Nøkkelingredienser'), [
        [T('Top 3', 'Topp 3'), function (p) { return '<div class="l27-act3">' + d(p).actives.map(function (a) { return '<span>' + (a[1] ? '<b>' + esc(a[1]) + '</b> ' : '') + esc(a[0]) + '</span>'; }).join('') + '</div>'; }],
        ['pH', function (p) { return '<span class="l27-num">' + esc(d(p).ph) + '</span>'; }],
        ['Type', function (p) { return esc(d(p).type); }]
      ]],
      ['use', T('Use', 'Bruk'), [
        [T('Size', 'Størrelse'), function (p) { return '<span class="l27-bigv">' + esc(String(p.ml).replace(/\s*ml/i, '')) + '</span><small>ml</small>'; }],
        [T('Pumps / applications', 'Antall pump / påføringer'), function (p) { return d(p).uses ? esc(d(p).uses) : dash; }],
        ['Dose', function (p) { return esc(d(p).dose) + (d(p).perUse ? '<small>' + esc(d(p).perUse) + '</small>' : ''); }],
        [T('Packaging', 'Emballasje'), function (p) { return esc(d(p).pack).replace(/^Airless /, 'Airless<br>'); }]
      ]],
      ['skin', T('Skin', 'Hud'), [
        [T('Skin type', 'Hudtype'), function (p) { return esc(d(p).skin); }],
        [T('Fragrance-free', 'Parfymefri'), function (p) { return d(p).fragrance ? ICON.check : dash; }],
        [T('Vegan', 'Vegansk'), function (p) { return d(p).vegan === true ? ICON.check : dash; }]
      ]],
      ['doc', T('Evidence', 'Dokumentasjon'), [['', function (p) { return d(p).study ? esc(d(p).study) : dash; }]]],
      ['price', T('Price', 'Pris'), [['', function (p) { return '<span class="l27-bigv">' + esc(p.price) + '</span>'; }]]]
    ];
    function opts(curH) {
      return Object.keys(lines).map(function (k) {
        var items = list.filter(function (p) { return d(p).line === k; });
        if (!items.length) return '';
        return '<optgroup label="' + esc(lines[k].label) + '">' + items.map(function (p) { return '<option value="' + esc(p.handle) + '"' + (p.handle === curH ? ' selected' : '') + '>' + esc(p.title) + '</option>'; }).join('') + '</optgroup>';
      }).join('');
    }
    function render() {
      var ps = sel.map(function (h) { return by[h]; });
      var h = '<div class="l27-cmp-sticky"><div class="l27-cols">' + ps.map(function (p, i) {
        return '<div class="l27-colsel c' + (i + 1) + '"><label class="l27-eyebrow" for="l27-cs' + i + '" style="display:block;margin-bottom:6px;font-size:11px">' + T('Product ', 'Produkt ') + (i + 1) + '</label><select id="l27-cs' + i + '" data-i="' + i + '">' + opts(p.handle) + '</select></div>';
      }).join('') + '</div></div>';
      h += '<div class="l27-cols">' + ps.map(function (p, i) {
        var l = lines[d(p).line];
        return '<div class="l27-coltop c' + (i + 1) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '<span class="l27-ln"><span class="l27-dot" style="background:' + l.c + '"></span>' + esc(l.label.split(' · ')[0]) + '</span><b>' + esc(p.title) + '</b><span class="l27-num">' + esc(p.price) + ' · ' + esc(p.ml) + '</span>' +
          (p.available ? '<form method="post" action="/cart/add"><input type="hidden" name="id" value="' + p.variant + '"><input type="hidden" name="quantity" value="1"><button class="l27-btn l27-btn--sm" type="submit">' + T('Add to bag', 'Legg i kurv') + '</button></form>' : '<span class="l27-dash">' + T('Sold out', 'Utsolgt') + '</span>') +
          '<a href="' + esc(p.url) + '">' + T('More about the product', 'Mer om produktet') + ' ›</a></div>';
      }).join('') + '</div>';
      ROWS.forEach(function (g) {
        if (hidden[g[0]]) return;
        h += '<div class="l27-grp"><h3>' + g[1] + '</h3>';
        g[2].forEach(function (r) {
          var vals = ps.map(r[1]);
          var same = vals.every(function (v) { return v === vals[0]; });
          h += '<div class="l27-row' + (diffOnly && same ? ' is-same' : '') + '">' + (r[0] ? '<div class="l27-rl">' + r[0] + '</div>' : '') + '<div class="l27-cols">' + vals.map(function (v, i) { return '<div class="l27-cell c' + (i + 1) + '">' + v + '</div>'; }).join('') + '</div></div>';
        });
        h += '</div>';
      });
      out.innerHTML = h;
      $$('select', out).forEach(function (s) {
        s.addEventListener('change', function () { sel[+s.getAttribute('data-i')] = s.value; render(); });
      });
    }
    $$('[data-grp]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var g = b.getAttribute('data-grp'); hidden[g] = !hidden[g];
        b.setAttribute('aria-pressed', hidden[g] ? 'false' : 'true'); render();
      });
    });
    var gs = root.querySelector('[data-l27-grpsel]');
    if (gs) gs.addEventListener('change', function () {
      var v = gs.value;
      $$('[data-grp]', root).forEach(function (b) {
        var g = b.getAttribute('data-grp');
        hidden[g] = v !== 'all' && g !== v;
        b.setAttribute('aria-pressed', hidden[g] ? 'false' : 'true');
      });
      render();
    });
    var df = root.querySelector('[data-l27-diff]');
    if (df) df.addEventListener('click', function () { diffOnly = !diffOnly; df.setAttribute('aria-pressed', diffOnly ? 'true' : 'false'); render(); });
    render();
  }

  function initInci(root) {
    var box = root.querySelector('[data-l27-inci-text]');
    var more = root.querySelector('[data-l27-inci-more]');
    var card = root.querySelector('[data-l27-ingcard]');
    if (!box) return;
    function setOpen(open) {
      box.classList.toggle('is-clamped', !open);
      if (more) { more.setAttribute('aria-expanded', open ? 'true' : 'false'); more.textContent = more.getAttribute(open ? 'data-close' : 'data-open'); }
    }
    if (more) {
      if (box.scrollHeight <= box.clientHeight + 2) { more.hidden = true; box.classList.remove('is-clamped'); }
      more.addEventListener('click', function () { setOpen(box.classList.contains('is-clamped')); });
    }
    var src = root.querySelector('[data-l27-inglib]');
    var lib = [];
    try { lib = src ? JSON.parse(src.textContent) : []; } catch (e) { lib = []; }
    lib = lib.filter(function (x) { return x && x.name; }).sort(function (a, b) { return b.name.length - a.name.length; });
    if (!lib.length) return;
    var byName = {};
    lib.forEach(function (x) { byName[x.name.toLowerCase()] = x; });
    var re = new RegExp('\\b(' + lib.map(function (x) { return x.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')\\b', 'gi');
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var txt = node.nodeValue; re.lastIndex = 0;
      if (!re.test(txt)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(txt))) {
        if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'l27-ing'; b.textContent = m[0];
        b.setAttribute('data-ing', m[0].toLowerCase());
        frag.appendChild(b);
        last = m.index + m[0].length;
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function rich(d) {
      if (!d) return '';
      if (typeof d === 'string') return '<p>' + esc(d) + '</p>';
      var out = '';
      (d.children || []).forEach(function (c) {
        var t = '';
        (function walk(k) { (k.children || []).forEach(function (x) { if (x.type === 'text') t += x.value; else walk(x); }); })(c);
        if (t) { var ta = document.createElement('textarea'); ta.innerHTML = t.replace(/<[^>]*>/g, ''); out += '<p>' + esc(ta.value) + '</p>'; }
      });
      return out;
    }
    var active = null;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.l27-ing');
      if (!b) return;
      var ing = byName[b.getAttribute('data-ing')];
      if (!ing || !card) return;
      if (active === b && !card.hidden) { card.hidden = true; b.setAttribute('aria-expanded', 'false'); active = null; return; }
      if (active) active.setAttribute('aria-expanded', 'false');
      active = b; b.setAttribute('aria-expanded', 'true');
      var r = Math.round(+ing.rating || 0), stars = '';
      for (var i = 1; i <= 4; i++) stars += '<span' + (i <= r ? '' : ' class="off"') + '>★</span>';
      var cat = Array.isArray(ing.cat) ? ing.cat.filter(function (c) { return c && c !== 'Uncategorized'; }) : [];
      card.innerHTML = '<button type="button" class="l27-ingx" aria-label="' + T('Close', 'Lukk') + '">×</button><h3>' + esc(ing.name) + '</h3>' + rich(ing.desc) +
        (cat.length ? '<p class="l27-ingmeta"><b>' + T('Category', 'Kategori') + '</b>' + esc(cat.join(', ')) + '</p>' : '') +
        (r > 0 ? '<p class="l27-ingmeta"><b>' + T('Rating', 'Vurdering') + '</b><span class="l27-ingstars" aria-label="' + r + T(' of 4', ' av 4') + '">' + stars + '</span></p>' : '') +
        (ing.url ? '<p class="l27-ingmeta"><a href="' + esc(ing.url) + '" style="font-weight:500;text-decoration:underline;text-underline-offset:3px">' + T('Read more about ', 'Les mer om ') + esc(ing.name) + ' →</a></p>' : '');
      card.hidden = false;
      card.querySelector('.l27-ingx').addEventListener('click', function () { card.hidden = true; if (active) { active.setAttribute('aria-expanded', 'false'); active.focus(); } active = null; });
      var rc = card.getBoundingClientRect();
      if (rc.bottom > window.innerHeight || rc.top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  function initSwipe(track) {
    if (track.__l27) return; track.__l27 = true;
    var gal = track.closest('[data-l27-gallery]') || track.parentNode;
    var slides = $$('.l27-slide', track), n = slides.length;
    if (n < 2) return;
    var dashes = gal.querySelector('[data-l27-dashes]');
    var pill = gal.querySelector('[data-l27-vjump]');
    var vs = track.querySelector('[data-l27-vslide]');
    var vidx = vs ? slides.indexOf(vs) : -1;
    var mq = window.matchMedia('(max-width:760px)');
    var cur = -1, raf = 0, t = 0, touched = false;
    if (dashes) dashes.innerHTML = slides.map(function () { return '<i></i>'; }).join('');
    var marks = dashes ? $$('i', dashes) : [];
    slides.forEach(function (s, i) {
      s.setAttribute('role', 'group'); s.setAttribute('aria-roledescription', 'bilde');
      s.setAttribute('aria-label', (i === vidx ? 'Video, ' : '') + (i + 1) + ' av ' + n);
    });
    if (pill) pill.hidden = !vs;
    function video() { return vs && vs.querySelector('video'); }
    function play(sound) {
      var v = video(); if (!v || !v.paused) return;
      if (!v.getAttribute('src')) { var im = vs.querySelector('img'); if (im) v.poster = im.currentSrc || im.src; v.src = v.getAttribute('data-src'); }
      v.hidden = false; vs.classList.add('is-playing'); v.muted = !sound;
      var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    }
    function stop() { var v = video(); if (v && !v.paused) v.pause(); }
    function step() { return slides[1].offsetLeft - slides[0].offsetLeft || track.clientWidth; }
    function update() {
      raf = 0;
      var i = Math.round(track.scrollLeft / step());
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) i = n - 1;
      i = Math.max(0, Math.min(n - 1, i));
      if (i !== cur) {
        cur = i;
        marks.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
        gal.classList.toggle('is-moved', i > 0);
      }
      clearTimeout(t);
      t = setTimeout(function () { if (cur === vidx && mq.matches) play(false); else stop(); }, 180);
    }
    function goTo(i) { track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); }
    function touch() { if (!touched) { touched = true; store.set('l27-swipe-hint', '1'); } }
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('pointerdown', touch, { passive: true });
    track.addEventListener('touchstart', touch, { passive: true });
    var vbtn = track.querySelector('[data-l27-vplay]');
    if (vbtn) vbtn.addEventListener('click', function () { touch(); play(true); });
    if (pill && vs) pill.addEventListener('click', function () { touch(); goTo(vidx); play(true); });
    if (mq.addEventListener) mq.addEventListener('change', function () { if (!mq.matches) stop(); });
    update();
    if (!store.get('l27-swipe-hint') && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        setTimeout(function () {
          if (touched || !mq.matches || track.scrollLeft > 0) return;
          track.classList.add('is-hint'); store.set('l27-swipe-hint', '1');
          setTimeout(function () { track.classList.remove('is-hint'); }, 1200);
        }, 900);
      }, { threshold: 0.6 });
      io.observe(track);
    }
  }

  function boot() {
    $$('[data-l27-main]').forEach(initMain);
    $$('[data-l27-clinical]').forEach(initClinical);
    $$('[data-l27-compare]').forEach(initCompare);
    $$('[data-l27-inci]').forEach(initInci);
    $$('[data-l27-track]').forEach(initSwipe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { window.__lab27 = true; boot(); });
})();
